import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppDispatch, AppState } from 'app/store'
import {
  getAssessmentsService,
  getClassesService
} from 'services/SelectAssessmentService'
import ClassRooms from 'services/modals/ClassRooms'
import Assessments from 'services/modals/Assessments'
import { putTestTimeService } from 'services/AssessmentService'

interface AssessmentState {
  assessments: Assessments
  classRooms: ClassRooms
  assessmentName: string
  loading: boolean
}

const initialState: AssessmentState = {
  assessments: [],
  classRooms: [],
  assessmentName: null!,
  loading: false
}

export const studentSlice = createSlice({
  name: 'assessmentReducer',
  initialState,
  reducers: {
    setAssessments: (state, action: PayloadAction<Assessments>) => {
      state.assessments = action.payload
    },
    setClassRooms: (state, action: PayloadAction<ClassRooms>) => {
      state.classRooms = action.payload
    },
    setSelectedAssessment: (state, action: PayloadAction<string>) => {
      state.assessmentName = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    resetAssessmentReducer: () => initialState
  }
})

export default studentSlice.reducer

export const {
  resetAssessmentReducer,
  setLoading,
  setAssessments,
  setClassRooms,
  setSelectedAssessment
} = studentSlice.actions

export const selectAssessments = (state: AppState) =>
  state.assessmentReducer.assessments

export const selectClassRooms = (state: AppState) =>
  state.assessmentReducer.classRooms
export const selectAssessmentName = (state: AppState) =>
  state.assessmentReducer.assessmentName
export const selectLoading = (state: AppState) =>
  state.assessmentReducer.loading

export const getAssessmentsAction =
  (classroomId: number) =>
  async (dispatch: AppDispatch, getState: () => AppState) => {
    const { loading } = getState().assessmentReducer
    if (loading) return

    dispatch(setLoading(true))
    try {
      const { summatives, formatives } =
        await getAssessmentsService(classroomId)
      const assessments = []

      assessments.push(
        ...summatives.map((summative: any) => ({
          ...summative,
          type: 'summatives'
        }))
      )

      assessments.push(
        ...formatives.map((formative: any) => ({
          ...formative,
          type: 'formatives'
        }))
      )

      dispatch(setAssessments(assessments))
    } finally {
      dispatch(setLoading(false))
    }
  }

export const getClassesAction =
  (callBack?: Function) =>
  async (dispatch: AppDispatch, getState: () => AppState) => {
    const { loading } = getState().assessmentReducer
    if (loading) return

    dispatch(setLoading(true))
    try {
      const { classrooms } = await getClassesService()
      dispatch(setClassRooms(classrooms))
      dispatch(setAssessments([]))
      callBack && callBack(false)
    } finally {
      dispatch(setLoading(false))
    }
  }

export const putTestTimeAction =
  (test_id: number, assessmentType: string, classroom_id: any) =>
  async (dispatch: AppDispatch) => {
    putTestTimeService(test_id, assessmentType, classroom_id)
  }
